export function getPublicArticleNumber(articleNumber: string | null | undefined) {
    return articleNumber && !/^__/.test(articleNumber) ? articleNumber : undefined;
}

export function isMenuCategory(itemId: string) {
    return /^CATEGORY-/.test(itemId);
}
